module.exports = __webpack_public_path__ + "static/media/calendar.e1016a92.svg";